import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import QualysWebappMappingForm_v1 from './QualysWebappMappingForm_v1';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { Alert } from 'antd';

function QualysWebappCredentialsForm(props, ref) {
    const fields = useMemo(() => [{
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    },{
        name: "username",
        label: "Username",
        required: true
    }, {
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        required: true
    },
    {
        name: "message",
        type: FieldTypes.LABEL,
        value: <Alert type='warning' message="Projects for this integration will be available after few minutes of adding the credentials, since they are pulled in background." />
    }
    ],[])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={QualysWebappMappingForm_v1}
            initialValue={{ apiEndpoint: 'https://qualysapi.qg3.apps.qualys.com' }}
        />
    )
}

export default forwardRef(QualysWebappCredentialsForm);